import React from 'react';
import PropTypes from 'prop-types';
import RichTextParser from '../RichTextParser/RichTextParser';
import styles from './Personalization.module.css';

// Component for personalized content display
function Personalization({ title, description }) {
  return (
    <div className={styles.container}>
      {title && (
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
        </div>
      )}
      <div className={styles.content}>
        {description && <RichTextParser document={description} />}
      </div>
    </div>
  );
}

Personalization.propTypes = {
  title: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ])
};

Personalization.defaultProps = {
  title: null,
  description: null
};

export default Personalization;
